module.exports = __webpack_public_path__ + "assets/img/581c84dbcb68bedcab0e2acdc701de07.svg";